import PropTypes from "prop-types";
import { memo } from "react";
import Button, { BUTTON_VARIANTS } from "app/pages/.shared/form/Button";
import "./FacebookLogin.scss";
import { FormattedMessage } from "react-intl";

const FacebookLogin = ({ isDisabled, onClick, isLoading }) => {
	return (
		<Button
			variant={BUTTON_VARIANTS.STROKE}
			loading={isLoading}
			onClick={onClick}
			disabled={isDisabled}
			icon={<i className="icon icon--facebook-rond" />}
			label={<FormattedMessage id="auth.facebook.button.label" />}
			className="button button--facebook"
			data-testid="facebook-login-button"
		/>
	);
};

FacebookLogin.propTypes = {
	onClick: PropTypes.func,
	isLoading: PropTypes.bool,
	isDisabled: PropTypes.bool,
};

export default memo(FacebookLogin);
